// Valores públicos (vão no bundle): endereço da API e ids do pool admin. Nada aqui é segredo.
export const env = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ?? 'https://api-backoffice.vslmax.com',
  userPoolId: (import.meta.env.VITE_COGNITO_USER_POOL_ID as string | undefined) ?? '',
  clientId: (import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined) ?? '',
}
